import "../../styles/ComponentsStyles/Universal/Modal.style.css"
import CloseBtnIcon from "../../assets/Icons/Universal/Cross.svg"
import PropTypes from "prop-types";

const Modal = ({ isOpen = false, onClose, title, description, children }) => {
    // if (!isOpen) return null;

    return (
        <div className={`modal ${isOpen ? "open" : "close"}`}>
            <div className="modalBackground" onClick={onClose}></div>
            <div className="modalContent">
                <div className="modalContentHeader">
                    <button className="modalCloseBtn" onClick={onClose}>
                        <img src={CloseBtnIcon} alt="" />
                    </button>
                </div>
                <div className="modalContentContainer">
                    {children}
                </div>
            </div>
        </div>
    );
};

export default Modal;


Modal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    children: PropTypes.element.isRequired
}